export default __webpack_public_path__ + "static/media/iam_parent.dca50a0e.svg";